import { Grid, GridItem } from "@chakra-ui/react";
import JackpotItem from "./components/JackpotItem";
import useIsLandScapeMachine from "../../hook/useIsLandScapeMachine";
import useJackpotQueries from "./hooks/useJackpotQueries";
import { useEffect, useState } from "react";

// API 的 jackpots key 是編號 "1"~"5",對應彩種與圖片(type 即圖片檔名 `${type}.png`)
const JACKPOT_CONFIG = [
  { apiKey: "1", type: "Grand" }, // GRAND 彩
  { apiKey: "2", type: "Mega" }, // MEGA 彩
  { apiKey: "3", type: "Major" }, // MAJOR 彩
  { apiKey: "4", type: "Minor" }, // Minor 彩
  { apiKey: "5", type: "Mini" }, // Mini 彩
];

const JackpotList = ({ fixed }) => {
  const [trigger, setTrigger] = useState(0);

  const fixedStyle = fixed
    ? {
        width: "-webkit-fill-available",
        bottom: "0px",
        position: "fixed",
      }
    : {};

  const isLandScapeMachine = useIsLandScapeMachine();

  const { jackpotList } = useJackpotQueries();

  // 每分鐘更新一次 trigger 以觸發動畫
  useEffect(() => {
    const interval = setInterval(() => {
      setTrigger((prev) => prev + 1);
    }, 15000);
    return () => clearInterval(interval);
  }, []);

  return (
    <Grid
      {...fixedStyle}
      display={{
        base: isLandScapeMachine ? "grid" : "none",
        md: "grid",
      }}
      templateColumns="repeat(5, 1fr)"
    >
      {JACKPOT_CONFIG.map(({ apiKey, type }) => (
        <GridItem key={type}>
          <JackpotItem
            jackpotValue={jackpotList?.[apiKey]}
            type={type}
            trigger={trigger}
          />
        </GridItem>
      ))}
    </Grid>
  );
};

export default JackpotList;
